import {
  addDays, differenceInCalendarDays, eachDayOfInterval, endOfMonth, format,
  startOfMonth, startOfWeek
} from 'date-fns'
import { formatDateValue, getDateFnsLocale, getWeekStartsOn } from '../utils'

export default class Month {
  constructor (month, year, locale, firstDayOfWeek) {
    this.locale = locale
    this.weekStartsOn = getWeekStartsOn(locale, firstDayOfWeek)
    this.start = startOfMonth(new Date(year, month, 1))
    this.end = endOfMonth(this.start)
    this.month = month
    this.year = year
  }

  getWeekStart () {
    return differenceInCalendarDays(this.start, startOfWeek(this.start, { weekStartsOn: this.weekStartsOn }))
  }

  getFormatted () {
    return format(this.start, 'MMMM', { locale: getDateFnsLocale(this.locale) })
  }

  getYear () {
    return format(this.start, 'yyyy')
  }

  getWeeks () {
    return Math.ceil((this.getWeekStart() + this.getMonthDays().length) / 7)
  }

  getMonthDays () {
    return eachDayOfInterval({ start: this.start, end: this.end })
  }
}

export const getWeekDays = (locale, firstDay) => {
  const weekStart = startOfWeek(new Date(2021, 0, 3), {
    locale: getDateFnsLocale(locale),
    weekStartsOn: getWeekStartsOn(locale, firstDay)
  })
  return Array.from({ length: 7 }, (_, index) => formatDateValue(addDays(weekStart, index), 'ddd', locale))
}

export const getMonthsShort = (locale) => {
  return Array.from({ length: 12 }, (_, month) => formatDateValue(new Date(2020, month, 1), 'MMM', locale))
}
